import { Checkbox, CheckboxGroup, FormControl, FormLabel, Radio, SimpleGrid, Textarea } from '@chakra-ui/react'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'

import { InputGroup } from '@/components/InputGroup'
import { FormBody } from '@/containers/forms/FormBody'
import { FormRow } from '@/containers/forms/FormRow'
import { RadioGroup } from '@/containers/forms/RadioGroup'
import { RadioStack } from '@/containers/forms/RadioStack'
import type { Step4FormValues } from '../Step4'

const RespectMeetingRecordForm = () => {

  const { register, setValue, control, formState: { errors } } = useFormContext<Step4FormValues>()

  const clientStatementTexts: { [key: string]: string } = {
    text1: 'Výše uvedené informace mu byly poskytnuty písemně, jasně a přesně, srozumitelnou formou, a to před uzavřením pojistné smlouvy a že jeho výše uvedené požadavky a potřeby jsou jasně a přesně srozumitelnou formou zaznamenány. Klient byl upozorněn na nesrovnalosti mezi požadavky klienta a nabízeným pojištěním a požaduje sjednat pojištění v souladu s nabídkou.',
    text2: 'Na žádost klienta mu byly tyto informace sděleny ústně jasně, přesně a srozumitelnou formou před uzavřením pojistné smlouvy. V písemné podobě mu byly poskytnuty neprodlené po uzavření pojistné smlouvy.'
  }
  const reasons: { id: number, description: string }[] = [
    { id: 1, description: 'Výše limitů' },
    { id: 2, description: 'Rozsah pojištění' },
    { id: 3, description: 'Výše spoluúčasti' },
    { id: 4, description: 'Cena produktu' },
  ]

  return (
    <FormBody>
      <FormRow>
        <FormControl isInvalid={!!errors.meetingRecord?.actingPersonName?.message}>
          <FormLabel>Jednající osoba</FormLabel>

          <InputGroup
            errors={errors.meetingRecord?.actingPersonName}
            {...register('meetingRecord.actingPersonName')}
          />
        </FormControl>

        <FormControl isInvalid={!!errors.meetingRecord?.actingPersonPhone?.message}>
          <FormLabel>Telefon</FormLabel>

          <InputGroup
            errors={errors.meetingRecord?.actingPersonPhone}
            {...register('meetingRecord.actingPersonPhone')}
          />
        </FormControl>

        <FormControl isInvalid={!!errors.meetingRecord?.actingPersonEmail?.message}>
          <FormLabel>Email</FormLabel>

          <InputGroup
            errors={errors.meetingRecord?.actingPersonEmail}
            {...register('meetingRecord.actingPersonEmail')}
          />
        </FormControl>
      </FormRow>

      <FormControl isInvalid={!!errors.meetingRecord?.irregularities?.message}>
        <FormLabel>
          Případné nesrovnalosti mezi požadavky Zákazníka a sjednávaným pojištěním nebo jeho podstatnou změnou
        </FormLabel>

        <InputGroup
          as={Textarea}
          errors={errors.meetingRecord?.irregularities}
          {...register('meetingRecord.irregularities')}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Pojišťovací zprostředkovatel doporučuje klientovi tento poj. produkt
        </FormLabel>

        <InputGroup
          as={Textarea}
          {...register('meetingRecord.agentProductRecommendation')}
          isDisabled={true}
        />

      </FormControl>

      <FormControl isInvalid={!!errors.meetingRecord?.reasons?.message}>
        <FormLabel>
          Specifikace požadavků klienta
        </FormLabel>

        <InputGroup
          as={Textarea}
          errors={errors.meetingRecord?.reasons}
          {...register('meetingRecord.reasons')}
        />
      </FormControl>

      <FormControl isInvalid={!!errors.meetingRecord?.insuranceInterest?.message}>
        <FormLabel>
          Pojistný zájem
        </FormLabel>

        <InputGroup
          as={Textarea}
          errors={errors.meetingRecord?.insuranceInterest}
          {...register('meetingRecord.insuranceInterest')}
        />
      </FormControl>

      <FormControl isInvalid={!!errors.meetingRecord?.warningsAndRecommendation?.message}>
        <FormLabel>
          Další doporučení a upozornění pojišťovacího zprostředkovatele
        </FormLabel>

        <InputGroup
          as={Textarea}
          errors={errors.meetingRecord?.warningsAndRecommendation}
          {...register('meetingRecord.warningsAndRecommendation')}
        />
      </FormControl>

      <FormControl w='100%' isInvalid={!!errors.meetingRecord?.productSelectionReasons}>

        <FormLabel htmlFor="meetingRecord.productSelectionReasons" >
          Důvody, na kterých pojišťovací zprostředkovatel zakládá svá doporučení pro výběr daného pojistného produktu
        </FormLabel>

        <Controller
          name="meetingRecord.productSelectionReasons"
          control={control}
          render={({ field: { onChange, value } }) => (
            <CheckboxGroup onChange={values => onChange(values.map(val => parseInt(val.toString())))} value={value}>
              <SimpleGrid columns={{ sm: 2, md: 4 }} spacingX='10' spacingY='4' w='100%'>
                {reasons.map(item => (
                  <Checkbox value={item.id} key={item.id}>
                    {item.description}
                  </Checkbox>
                ))}
              </SimpleGrid>
            </CheckboxGroup>
          )}
        />
      </FormControl>

      <FormControl isInvalid={!!errors.meetingRecord?.clientStatementChoice?.message}>
        <FormLabel>Prohlášení klienta</FormLabel>

        <RadioGroup
          {...register('meetingRecord.clientStatementChoice')}
          valueTransform={(value) => value?.toString()}
          onChange={e => setValue('meetingRecord.clientStatementChoice', parseInt(e))}
        >
          <RadioStack variant='simple' sx={{ gridAutoFlow: 'row' }}>
            <Radio value={'1'} key={'r1'}>{clientStatementTexts['text1']}</Radio>
            <Radio value={'2'} key={'r2'}>{clientStatementTexts['text2']}</Radio>
          </RadioStack>
        </RadioGroup>

      </FormControl>

      <FormRow>
        <FormControl isInvalid={!!errors.meetingRecord?.placeOfContract?.message}>
          <FormLabel>Sjednáno v</FormLabel>

          <InputGroup
            errors={errors.meetingRecord?.placeOfContract}
            {...register('meetingRecord.placeOfContract')}
          />
        </FormControl>
      </FormRow>
    </FormBody>
  )
}

export default RespectMeetingRecordForm